export function generateRandomId() {
	return Math.random().toString(16).slice(-6);
}
